// extracted by mini-css-extract-plugin
export var bigText = "PageIntro-module--big-text--4cd72";
export var centered = "PageIntro-module--centered--70497";
export var pageIntro = "PageIntro-module--page-intro--a6da4";
export var richText = "PageIntro-module--rich-text--d57e5";
export var subtitle = "PageIntro-module--subtitle--80ca9";
export var text = "PageIntro-module--text--21d4f";
export var title = "PageIntro-module--title--72046";
export var wrapper = "PageIntro-module--wrapper--933c5";